// suite.js
import { create, test, enforce, only } from 'vest';
import { isEmail } from 'validator';

enforce.extend({ isEmail });

const suite = create((data = {}, fieldName) => {
  only(fieldName);
  test('emailAddress', 'Email Address is required', () => {
    enforce(data.emailAddress).isNotBlank();
  });
  test('emailAddress', 'Email Address is not valid', () => {
    enforce(data.emailAddress).isEmail();
  });
});

export default suite;
